// extracted by mini-css-extract-plugin
export var root = "W6KzkfAFwQogUJ7OzdOf";